import { Link, useNavigate } from 'react-router-dom';
import { ShoppingBag } from '@phosphor-icons/react';
import { toast } from 'sonner';
import { useCart } from '../lib/CartContext';

const Navbar = ({ user, onLogout }) => {
  const navigate = useNavigate();
  const { totalItems, openDrawer } = useCart();

  const handleLogout = () => {
    onLogout();
    toast.success('Logged out successfully');
    navigate('/');
  };

  return (
    <nav
      className="fixed top-0 left-0 right-0 z-50 bg-black border-b border-white/10"
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-14 sm:h-16">
          <Link
            to="/"
            className="logo-font text-2xl sm:text-3xl text-foreground hover:opacity-80 transition-opacity"
            data-testid="logo-link"
          >
            POSTERLY
          </Link>

          <div className="flex items-center gap-4 sm:gap-6 md:gap-8">
            <Link
              to="/"
              className="text-foreground/80 hover:text-foreground transition-colors text-xs sm:text-sm font-medium"
              data-testid="home-link"
            >
              Home
            </Link>
            <Link
              to="/shop"
              className="text-foreground/80 hover:text-foreground transition-colors text-xs sm:text-sm font-medium"
              data-testid="shop-link"
            >
              Shop
            </Link>
            <Link
              to="/categories"
              className="text-foreground/80 hover:text-foreground transition-colors text-xs sm:text-sm font-medium"
              data-testid="categories-link"
            >
              Categories
            </Link>
            {user && (
              <>
                <Link
                  to="/admin/dashboard"
                  className="text-foreground/80 hover:text-foreground transition-colors text-xs sm:text-sm font-medium hidden md:inline"
                  data-testid="dashboard-link"
                >
                  Dashboard
                </Link>
                <button
                  onClick={handleLogout}
                  className="text-foreground/80 hover:text-foreground transition-colors text-xs sm:text-sm font-medium"
                  data-testid="logout-button"
                >
                  Logout
                </button>
              </>
            )}
            <button
              onClick={openDrawer}
              className="relative text-foreground/80 hover:text-foreground transition-colors p-1"
              aria-label={`Open cart (${totalItems} items)`}
              data-testid="open-cart-button"
            >
              <ShoppingBag size={22} weight="regular" />
              {totalItems > 0 && (
                <span
                  className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 flex items-center justify-center rounded-full bg-white text-black text-[10px] font-bold leading-none"
                  data-testid="cart-badge"
                >
                  {totalItems > 99 ? '99+' : totalItems}
                </span>
              )}
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
